import * as React from 'react';
import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import UploadUneditedImages, {
    UploadUneditedImagesLabels
} from '../../uneditedImages/view/UploadUneditedImages';
import UploadEditedImages from '../../editedImages/view/UploadEditedImages';
import { a11yProps, StyledTab, TabPanel } from '../../../shared/view/TabPanel';

export type DigitalStylingImageProcessingTabPanelLabels = {
    editedTab: string;
    uneditedTab: string;
} & UploadUneditedImagesLabels;

type DigitalStylingImageProcessingTabPanelProps = {
    labels: DigitalStylingImageProcessingTabPanelLabels;
    orderId: number;
};

enum ImageTabs {
    Unedited = 0,
    Edited = 1
}

export function DigitalStylingImageProcessingTabPanel({
    labels,
    orderId
}: DigitalStylingImageProcessingTabPanelProps) {
    let [currentTab, setCurrentTab] = React.useState<ImageTabs>(ImageTabs.Unedited);

    function handleChangeTab(event: React.SyntheticEvent, nextTab: number) {
        setCurrentTab(nextTab);
    }

    return (
        <Paper>
            <Tabs
                value={currentTab}
                onChange={handleChangeTab}
                variant="fullWidth"
                aria-label="Image processing tabs"
            >
                <StyledTab label={labels.uneditedTab} {...a11yProps(ImageTabs.Unedited)} />
                <StyledTab label={labels.editedTab} {...a11yProps(ImageTabs.Edited)} />
            </Tabs>
            <TabPanel currentTab={currentTab} connectedTab={ImageTabs.Unedited}>
                <UploadUneditedImages labels={labels} orderId={orderId} />
            </TabPanel>
            <TabPanel currentTab={currentTab} connectedTab={ImageTabs.Edited}>
                <UploadEditedImages labels={labels} orderId={orderId} />
            </TabPanel>
        </Paper>
    );
}
